(function () {
  var currentUrl = window.location.pathname;
  var search = window.location.search || "";
  var hash = window.location.hash || "";

  // Normalize path (remove trailing slash except root)
  if (currentUrl.length > 1 && currentUrl.endsWith("/")) {
    currentUrl = currentUrl.slice(0, -1);
  }

  var redirectTo = null;

  /*
    WordPress Product:
    /product/product-slug
    → /products/product-slug
  */
  if (currentUrl.startsWith("/product/")) {
    var productSlug = currentUrl.replace("/product/", "");
    redirectTo = "/products/" + productSlug;
  }

  /*
    WordPress Category:
    /product-category/books
    /product-category/parent/child
    → /collections/books
    → /collections/child  (Shopify only supports one level)
  */
  if (currentUrl.startsWith("/product-category/")) {
    var categoryPath = currentUrl.replace("/product-category/", "");

    // If parent/child exists, take last segment
    var segments = categoryPath.split("/");
    var collectionHandle = segments[segments.length - 1];

    redirectTo = "/collections/" + collectionHandle;
  }

  /*
    Prevent redirect loop
  */
  if (
    redirectTo &&
    window.location.pathname !== redirectTo
  ) {
    window.location.replace(redirectTo + search + hash);
  }
})();